// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'moment-jalaali'

// plugins
import axios from 'axios'
import VueAxios from 'vue-axios'

// styles

import '@/styles/IRANSans.css'
import '@/styles/theme.scss'
// import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.css'

// config axios
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.withCredentials = true
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

// get majors and cities
let url = process.env.ROOT_URL + '/api/members/initialdata'
axios.get(url)
  .then(res => {
    if (res.data.cities) {
      res.data.cities.sort(function (a, b) {
        return a.name.localeCompare(b.name, 'fa')
      })
    }
    window.vm = new Vue({
      el: '#app',
      data () {
        return {
          rootUrl: process.env.ROOT_URL,
          apiUrl: process.env.ROOT_URL + '/api',
          majors: res.data.majors,
          cities: res.data.cities,
          member: null,
          refCount: 0,
          isLoading: false
        }
      },
      methods: {
        toPersianDate (date) {
          if (date) {
            return moment(date, 'YYYY-M-D').format('jYYYY/jM/jD')
          } else {
            return ''
          }
        },
        toGregorianDate (date) {
          if (date) {
            return moment(date, 'jYYYY/jM/jD').format('M/D/YYYY')
          } else {
            return ''
          }
        },
        checkPersianDate (e) {
          if (e.target.value.length && !moment(e.target.value, 'jYYYY/jM/jD').isValid()) {
            e.target.setCustomValidity('تاریخ وارد شده معتبر نیست')
          } else {
            e.target.setCustomValidity('')
          }
        },
        majorIdToTitle (id) {
          if (id) {
            let index = this.majors.findIndex(x => x.id === Number(id))
            if (index > -1) {
              return this.majors[index].name
            }
          }
          return ''
        },
        cityIdToTitle (id) {
          if (id) {
            let index = this.cities.findIndex(x => x.id === Number(id))
            if (index > -1) {
              return this.cities[index].name
            }
          }
          return ''
        },
        setLoading (isLoading) {
          if (isLoading) {
            this.refCount++
            this.isLoading = true
          } else if (this.refCount > 0) {
            this.refCount--
            this.isLoading = (this.refCount > 0)
          }
        }
      },
      router,
      components: { App },
      template: '<App/>',
      created () {
        axios.interceptors.request.use((config) => {
          this.setLoading(true)
          return config
        }, (error) => {
          this.setLoading(false)
          return Promise.reject(error)
        })

        axios.interceptors.response.use((response) => {
          this.setLoading(false)
          return response
        }, (error) => {
          this.setLoading(false)
          return Promise.reject(error)
        })
      }
    })
  })
/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js